import { InventoryFlow, AdgroupFormData, CampaignFormData, AdgroupConfig } from '@tt4b/ttam-enums';
import { computed, onMounted, ref, Ref } from '@vue/composition-api';
import {
  useStdAdgroupAmazon,
  useTanblockIdsApi,
  useTanblockListApi,
  useStdAdgroupIs,
  useNewTanblockIdsApi,
  useNewTanblockListApi,
  useAllowlist,
} from '@tt4b/ttam-hooks';

/**
 * block list hooks
 */
export function useSwitchPropsDisabled(props: { adgroupConfig: Ref<AdgroupConfig> }) {
  const { adgroupConfig } = props;
  return {
    disabled: computed(() => adgroupConfig.value?.disablePangleBlockList),
  };
}

export function usePropsVisible(props: { adgroupData: Ref<AdgroupFormData>; campaignData: Ref<CampaignFormData> }) {
  const { hasInventoryFlow } = useStdAdgroupIs({
    campaignFormData: props.campaignData,
    adgroupFormData: props.adgroupData,
  });

  const { isAmazonTraffic } = useStdAdgroupAmazon({
    campaignFormData: props.campaignData,
  });

  return {
    visible: computed(() => hasInventoryFlow(InventoryFlow.TIKTOKADNETWORK) && !isAmazonTraffic.value),
  };
}

export function useDataSource() {
  const isLoading = ref(false);
  const tanBlockId = ref<string>('0');
  const tanBlockList = ref<string[]>([]);
  const tanBlockCount = computed(() => tanBlockList.value.length || 0);

  const { isBrandBlockList } = useAllowlist();

  const run = async () => {
    try {
      isLoading.value = true;
      // const tanId = await useTanblockIdsApi();
      // tanBlockId.value = tanId || '0';

      // if (Number(tanId)) {
      //   tanBlockList.value = (await useTanblockListApi()) || [];
      // }
      const _useTanblockIdsApi = isBrandBlockList.value ? useNewTanblockIdsApi : useTanblockIdsApi;
      const _useTanblockListApi = isBrandBlockList.value ? useNewTanblockListApi : useTanblockListApi;

      const [tanId, tanList] = await Promise.all([_useTanblockIdsApi(), _useTanblockListApi()]);

      tanBlockId.value = tanId || '0';
      tanBlockList.value = tanList || [];
    } finally {
      isLoading.value = false;
    }
  };

  onMounted(() => {
    run();
  });

  return {
    isLoading,
    tanBlockId,
    tanBlockList,
    tanBlockCount,
    run,
  };
}
